import { render, staticRenderFns } from "./newvideo.vue?vue&type=template&id=0649b28b&scoped=true"
import script from "./newvideo.vue?vue&type=script&lang=js"
export * from "./newvideo.vue?vue&type=script&lang=js"
import style0 from "./newvideo.vue?vue&type=style&index=0&id=0649b28b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649b28b",
  null
  
)

export default component.exports